<template>
  <m-form :formModel="formModel" ref="form" />
</template>

<script>
import MForm from './m-form'
import { getCustomerOverview } from 'views/client/client-center/detail/mechanism/api'
export default {
  data() {
    return {
      formModel: [
        {
          type: 'select',
          label: '匹配类型',
          defaultValue: 1,
          key: 'matchUniverse',
          selectList: [
            {
              id: 1,
              name: 'All Businesses',
            },
            {
              id: 2,
              name: 'In Date Financials Only',
            },
            {
              id: 3,
              name: 'Major Buinesses Only',
            },
          ],
          rule: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
        },
        {
          type: 'input',
          label: '股票代码',
          key: 'tickerSymbol',
          rule: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
          ],
        },
      ],
    }
  },
  created() {
    this._getCustomerOverview()
  },
  methods: {
    async _getCustomerOverview() {
      try {
        const { data } = await getCustomerOverview(this.$route.params.id)
        this.formModel.forEach((item, index) => {
          if (item.key === 'tickerSymbol') {
            this.formModel.splice(index, 1, {
              ...item,
              defaultValue: data.base.tickerSymbol,
            })
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    async validate() {
      return await this.$refs.form.validateForm()
    },
  },
  components: {
    MForm,
  },
}
</script>
